import { render, staticRenderFns } from "./tableOtherPlatform.vue?vue&type=template&id=90d14302&scoped=true&"
import script from "./tableOtherPlatform.vue?vue&type=script&lang=js&"
export * from "./tableOtherPlatform.vue?vue&type=script&lang=js&"
import style0 from "./tableOtherPlatform.vue?vue&type=style&index=0&id=90d14302&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d14302",
  null
  
)

export default component.exports